
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("5qO2k", function(module, exports) {
// Intent-time preload seam for chat-side modules. Fire-and-forget; experiment-gated; once per page load.

var $cXtTj = parcelRequire("cXtTj");

// Intent-time preload for the LazyCardWithUrlContent chunk; chunk name mirrors `view/CardWithUrl/loader.tsx`.

const $8f621f3867006eb3$export$e8ff3768de40dcb2 = ()=>(parcelRequire("fboML"));



var $hyOW3 = parcelRequire("hyOW3");


var $fDOrD = parcelRequire("fDOrD");


var $jv1SC = parcelRequire("jv1SC");

const $6e95e9a207754122$var$PRELOADER_SMART_CARD = 'smart-card';
const $6e95e9a207754122$var$PRELOADER_AUTO_SUGGEST = 'auto-suggest';
const $6e95e9a207754122$var$PRELOADER_SMART_CREATION = 'smart-creation';
const $6e95e9a207754122$var$PRELOADER_FEEDBACK_FLAG = 'feedback-flag';
const $6e95e9a207754122$var$ALL_PRELOADERS = [
    $6e95e9a207754122$var$PRELOADER_SMART_CARD,
    $6e95e9a207754122$var$PRELOADER_AUTO_SUGGEST,
    $6e95e9a207754122$var$PRELOADER_SMART_CREATION,
    $6e95e9a207754122$var$PRELOADER_FEEDBACK_FLAG
];
let $6e95e9a207754122$var$hasPreloadedChatOnIntent = false;
function $6e95e9a207754122$var$isPreloaderName(preloader) {
    return $6e95e9a207754122$var$ALL_PRELOADERS.includes(preloader);
}
function $6e95e9a207754122$var$getEnabledPreloaders(cohort) {
    return new Set(cohort.split(',').map((preloader)=>preloader.trim()).filter(Boolean).filter($6e95e9a207754122$var$isPreloaderName));
}
function $6e95e9a207754122$var$preloadSmartCard() {
    (0, $8f621f3867006eb3$export$e8ff3768de40dcb2)().catch(()=>{});
}
function $6e95e9a207754122$var$preloadAutoSuggest() {
    (0, $hyOW3.importAutoSuggest)().catch(()=>{});
}
function $6e95e9a207754122$var$preloadSmartCreationWrapper() {
    (0, $jv1SC.importSmartCreationWrapper)().catch(()=>{});
}
function $6e95e9a207754122$var$preloadFeedbackFlag() {
    (0, $fDOrD.importFeedbackFlag)().catch(()=>{});
}
function $6e95e9a207754122$export$778f6ecee92cc30c() {
    if (typeof window === 'undefined') return;
    if ($6e95e9a207754122$var$hasPreloadedChatOnIntent) return;
    $6e95e9a207754122$var$hasPreloadedChatOnIntent = true;
    const enabledPreloaders = $6e95e9a207754122$var$getEnabledPreloaders((0, $cXtTj.default).getExperimentValue('chat_preload_components_exp', 'cohort', '', {
        fireExperimentExposure: true
    }));
    if (enabledPreloaders.size === 0) return;
    if (enabledPreloaders.has($6e95e9a207754122$var$PRELOADER_SMART_CARD)) $6e95e9a207754122$var$preloadSmartCard();
    if (enabledPreloaders.has($6e95e9a207754122$var$PRELOADER_AUTO_SUGGEST)) $6e95e9a207754122$var$preloadAutoSuggest();
    if (enabledPreloaders.has($6e95e9a207754122$var$PRELOADER_SMART_CREATION)) $6e95e9a207754122$var$preloadSmartCreationWrapper();
    if (enabledPreloaders.has($6e95e9a207754122$var$PRELOADER_FEEDBACK_FLAG)) $6e95e9a207754122$var$preloadFeedbackFlag();
}
module.exports["preloadChatOnIntent"] = $6e95e9a207754122$export$778f6ecee92cc30c;

});

parcelRegister("fboML", function(module, exports) {

let $b0db1bf760633702$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b0db1bf760633702$var$load("j6n20"),
    $b0db1bf760633702$var$load("gpnR1"),
    $b0db1bf760633702$var$load("dds2B"),
    $b0db1bf760633702$var$load("35uOz"),
    $b0db1bf760633702$var$load("eRhBr"),
    $b0db1bf760633702$var$load("1wtmT"),
    $b0db1bf760633702$var$load("85Or1"),
    $b0db1bf760633702$var$load("hZ2FX"),
    $b0db1bf760633702$var$load("9ZFGK"),
    $b0db1bf760633702$var$load("2hLAI"),
    $b0db1bf760633702$var$load("dCilB"),
    $b0db1bf760633702$var$load("h1yOv"),
    $b0db1bf760633702$var$load("1T8H1"),
    $b0db1bf760633702$var$load("fyKFO"),
    $b0db1bf760633702$var$load("d9sg7"),
    $b0db1bf760633702$var$load("l0N35"),
    $b0db1bf760633702$var$load("bU9L5"),
    $b0db1bf760633702$var$load("fuOfV"),
    $b0db1bf760633702$var$load("iZR3N"),
    $b0db1bf760633702$var$load("4zz48"),
    $b0db1bf760633702$var$load("jXM1T"),
    $b0db1bf760633702$var$load("cvcNg"),
    $b0db1bf760633702$var$load("jw3lv"),
    $b0db1bf760633702$var$load("7rqWx"),
    $b0db1bf760633702$var$load("aIze1"),
    $b0db1bf760633702$var$load("il8bj"),
    $b0db1bf760633702$var$load("4N1MY"),
    $b0db1bf760633702$var$load("kG5Ju"),
    $b0db1bf760633702$var$load("39XCn"),
    $b0db1bf760633702$var$load("3Cky6"),
    $b0db1bf760633702$var$load("jL1Ke"),
    $b0db1bf760633702$var$load("5MQ0D"),
    $b0db1bf760633702$var$load("aFLSJ"),
    $b0db1bf760633702$var$load("6fJCf"),
    $b0db1bf760633702$var$load("duEFL"),
    $b0db1bf760633702$var$load("6wr18"),
    $b0db1bf760633702$var$load("1pJPT"),
    $b0db1bf760633702$var$load("8zMmc"),
    $b0db1bf760633702$var$load("4x9Jx"),
    $b0db1bf760633702$var$load("7EorR"),
    $b0db1bf760633702$var$load("ffEVr"),
    $b0db1bf760633702$var$load("2EIkU"),
    $b0db1bf760633702$var$load("Wowvf"),
    $b0db1bf760633702$var$load("hhss7"),
    $b0db1bf760633702$var$load("cbF85")
]).then(()=>parcelRequire('9gHOR'));

});

parcelRegister("hyOW3", function(module, exports) {
// Canonical dynamic-import factory for `@atlassian/conversation-assistant-auto-suggest`. Shared by the live
// `lazy()` boundary and intent-time preload to keep chunk identity single-sourced.

function $04373e772f510be6$export$5531859f311f2932() {
    return (parcelRequire("iqZUu"));
}
module.exports["importAutoSuggest"] = $04373e772f510be6$export$5531859f311f2932;

});

parcelRegister("iqZUu", function(module, exports) {

let $d6baadbe02e8963d$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $d6baadbe02e8963d$var$load("dds2B"),
    $d6baadbe02e8963d$var$load("35uOz"),
    $d6baadbe02e8963d$var$load("6wr18"),
    $d6baadbe02e8963d$var$load("ffEVr"),
    $d6baadbe02e8963d$var$load("dGhn8"),
    $d6baadbe02e8963d$var$load("5omeF"),
    $d6baadbe02e8963d$var$load("2EIkU"),
    $d6baadbe02e8963d$var$load("eRhBr"),
    $d6baadbe02e8963d$var$load("hZ2FX"),
    $d6baadbe02e8963d$var$load("hhss7"),
    $d6baadbe02e8963d$var$load("kT6dz"),
    $d6baadbe02e8963d$var$load("aAWLw"),
    $d6baadbe02e8963d$var$load("lRgOm")
]).then(()=>parcelRequire('79mXg'));

});

parcelRegister("fDOrD", function(module, exports) {
// Single-source dynamic import factory for the feedback-flag chunk.
// Mirrors the chunk-name used by every live `lazy()` boundary so preload and
// the live boundary share the same chunk identity.

const $e837e744ff2037be$export$1eafe3a5df99a0a0 = ()=>(parcelRequire("wRQb5"));
module.exports["importFeedbackFlag"] = $e837e744ff2037be$export$1eafe3a5df99a0a0;

});

parcelRegister("wRQb5", function(module, exports) {

let $062cc0e3f374f5be$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $062cc0e3f374f5be$var$load("hMCSF").then(()=>parcelRequire('3XAon'));

});

parcelRegister("jv1SC", function(module, exports) {
// Single-source dynamic import factory for the smart-creation-wrapper chunk.
// Mirrors the chunk-name used by every live `lazy()` boundary so preload and
// the live boundary share the same chunk identity.

const $bf344f5862a0f71d$export$f67978e62543a686 = ()=>(parcelRequire("4PIFP"));
module.exports["importSmartCreationWrapper"] = $bf344f5862a0f71d$export$f67978e62543a686;

});

parcelRegister("4PIFP", function(module, exports) {

let $384e941380c027cd$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $384e941380c027cd$var$load("4ZKBo"),
    $384e941380c027cd$var$load("3WmaY"),
    $384e941380c027cd$var$load("7TnhR"),
    $384e941380c027cd$var$load("hUbK8"),
    $384e941380c027cd$var$load("gwGEC"),
    $384e941380c027cd$var$load("l5nRU"),
    $384e941380c027cd$var$load("bx5S2"),
    $384e941380c027cd$var$load("7fsAO"),
    $384e941380c027cd$var$load("1tkCm"),
    $384e941380c027cd$var$load("ipIDQ"),
    $384e941380c027cd$var$load("7eTC9"),
    $384e941380c027cd$var$load("agv3Q"),
    $384e941380c027cd$var$load("garBx"),
    $384e941380c027cd$var$load("6GBKZ"),
    $384e941380c027cd$var$load("28xpM"),
    $384e941380c027cd$var$load("6jAZt"),
    $384e941380c027cd$var$load("jioFR"),
    $384e941380c027cd$var$load("3cN9G"),
    $384e941380c027cd$var$load("j3345"),
    $384e941380c027cd$var$load("2J2X1"),
    $384e941380c027cd$var$load("iBQFK"),
    $384e941380c027cd$var$load("jgxNN"),
    $384e941380c027cd$var$load("e7Dyr"),
    $384e941380c027cd$var$load("XbUoB"),
    $384e941380c027cd$var$load("iUz8S"),
    $384e941380c027cd$var$load("6cD8V"),
    $384e941380c027cd$var$load("2NEDA"),
    $384e941380c027cd$var$load("dxcsb"),
    $384e941380c027cd$var$load("gbejv"),
    $384e941380c027cd$var$load("GD9EA"),
    $384e941380c027cd$var$load("2hLAI"),
    $384e941380c027cd$var$load("dCilB"),
    $384e941380c027cd$var$load("1T8H1"),
    $384e941380c027cd$var$load("fyKFO"),
    $384e941380c027cd$var$load("d9sg7"),
    $384e941380c027cd$var$load("l0N35"),
    $384e941380c027cd$var$load("gnocL"),
    $384e941380c027cd$var$load("j6n20"),
    $384e941380c027cd$var$load("gpnR1"),
    $384e941380c027cd$var$load("1Zk4x"),
    $384e941380c027cd$var$load("8exG0"),
    $384e941380c027cd$var$load("kT6dz"),
    $384e941380c027cd$var$load("jZMUd"),
    $384e941380c027cd$var$load("dds2B"),
    $384e941380c027cd$var$load("35uOz"),
    $384e941380c027cd$var$load("6wr18"),
    $384e941380c027cd$var$load("diUSq"),
    $384e941380c027cd$var$load("hZVEi"),
    $384e941380c027cd$var$load("ekVH8"),
    $384e941380c027cd$var$load("ffEVr"),
    $384e941380c027cd$var$load("dGhn8"),
    $384e941380c027cd$var$load("5omeF"),
    $384e941380c027cd$var$load("ddvkk"),
    $384e941380c027cd$var$load("3upHR"),
    $384e941380c027cd$var$load("hhss7"),
    $384e941380c027cd$var$load("Wowvf"),
    $384e941380c027cd$var$load("eRhBr"),
    $384e941380c027cd$var$load("hZ2FX"),
    $384e941380c027cd$var$load("cKDij"),
    $384e941380c027cd$var$load("7EorR"),
    $384e941380c027cd$var$load("ce05o"),
    $384e941380c027cd$var$load("4CnWt")
]).then(()=>parcelRequire('j1zzQ'));

});


//# sourceMappingURL=preload-chat-on-intent.da2ae8f2.js.map
